import { render, staticRenderFns } from "./tabProtocol.vue?vue&type=template&id=e32b41f6&scoped=true"
import script from "./tabProtocol.vue?vue&type=script&lang=js"
export * from "./tabProtocol.vue?vue&type=script&lang=js"
import style0 from "./tabProtocol.vue?vue&type=style&index=0&id=e32b41f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32b41f6",
  null
  
)

export default component.exports